query LpActiveSeason {
  lpActiveSeason {
    id
    propsContent {
      type
      props
    }
    coinLifetimeDays
    activeSettings {
      activeStart
      activeEnd
    }
  }
}
